import type { COST_TYPE } from '@/app/types';

/**
 * 生成积分消耗 Map 的 key
 * @param costType - 消耗类型
 * @param duration - 时长
 * @returns key 字符串，例如 "video_generate_15"
 */
export function getCostMapKey(costType: COST_TYPE, duration: number): string {
  return `${costType}_${duration}`;
}
